import { render, staticRenderFns } from "./DBindNew.vue?vue&type=template&id=e9c3f5ba&"
import script from "./DBindNew.vue?vue&type=script&lang=js&"
export * from "./DBindNew.vue?vue&type=script&lang=js&"
import style0 from "./DBindNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports